// // firebase.js
// import { initializeApp } from 'firebase/app';
// import { getAuth } from 'firebase/auth';

// const firebaseConfig = {
//   apiKey: '',
//   authDomain: '',
//   projectId: '',
//   storageBucket: '',
//   messagingSenderId: '',
//   appId: '',
//   measurementId: '',
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);

// export { auth };

// firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyB91olPodoEVXXDnLjK7TrtbYDMIVHIiIw',
  authDomain: 'rdms-683cb.firebaseapp.com',
  projectId: 'rdms-683cb',
  storageBucket: 'rdms-683cb.firebasestorage.app',
  messagingSenderId: '224368713987',
  appId: '1:224368713987:web:932afc076d3d79d5c60936',
  measurementId: 'G-C0KQXE2NV9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
